<template>
  <div>
    <div class="relative">
      <div class="w-full aspect-w-10 aspect-h-7 rounded-lg overflow-hidden">
        <img
          v-if="isImage"
          :src="assetable.url"
          alt=""
          class="group-hover:opacity-75 object-cover pointer-events-none"
        />
        <img
          v-else-if="isLinkWithCover"
          :src="assetable.cover"
          alt=""
          class="group-hover:opacity-75 object-cover pointer-events-none"
        />
        <div
          v-else
          class="w-full h-full flex items-center cursor-default justify-center bg-gray-600 group-hover:opacity-75"
        >
          <span
            v-if="isVideo"
            class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800"
          >
            Video
          </span>
          <span
            v-else-if="isLink"
            class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800"
          >
            Link
          </span>
          <span
            v-else-if="isNote"
            class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800"
          >
            Note
          </span>
          <svg
            v-else
            class="w-8 h-8 text-gray-300"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0
              1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0
              3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
      </div>
    </div>
    <div v-if="assetable" class="mt-2 text-center space-x-2">
      <BaseButton v-if="!added" type="button" small primary @click="addAsset">
        <Loader small inverse v-if="pending" />
        <span v-else>Add Asset</span>
      </BaseButton>
      <BaseButton
        v-if="isMedia || isLink"
        tag="a"
        target="_blank"
        :href="assetable.url"
        small
        success
      >
        View
      </BaseButton>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['createLink', 'createNote'],
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
      added: false,
    };
  },
  computed: {
    isMedia() {
      return typeof this.asset.media === 'string';
    },
    isLink() {
      return typeof this.asset.link === 'string';
    },
    isNote() {
      return typeof this.asset.note === 'string';
    },
    assetable() {
      if (this.isMedia) {
        return this.$store.state.entities.media.byId[this.asset.assetableId];
      }

      if (this.isLink) {
        return this.$store.state.entities.links.byId[this.asset.assetableId];
      }

      if (this.isNote) {
        return this.$store.state.entities.notes.byId[this.asset.assetableId];
      }

      return null;
    },
    isImage() {
      if (!this.isMedia) {
        return false;
      }

      const { mimeType = '' } = this.assetable || {};

      return mimeType.indexOf('image/') === 0;
    },
    isLinkWithCover() {
      return this.isLink && typeof this.assetable.cover === 'string';
    },
    isVideo() {
      if (!this.isMedia) {
        return false;
      }

      const { mimeType = '' } = this.assetable || {};

      return mimeType.indexOf('video/') === 0;
    },
  },
  methods: {
    async addAsset() {
      if (this.pending) {
        return;
      }

      try {
        this.pending = true;

        if (this.isLink || this.isMedia) {
          await this.createLink({
            description: this.assetable?.description || null,
            title: this.assetable?.title || null,
            url: this.assetable.url,
          });
        }

        if (this.isNote) {
          await this.createNote({
            content: this.assetable.content,
          });
        }

        this.added = true;
      } catch (error) {
        //
      } finally {
        this.pending = false;
      }
    },
  },
};
</script>
